import { Controller } from "@hotwired/stimulus"

// Generic controller that navigates a Turbo Frame when a select value changes.
// Usage:
// <select data-controller="dependent-frame"
//         data-dependent-frame-url-template-value="/items/__ID__/details"
//         data-dependent-frame-frame-value="details_frame"
//         data-action="change->dependent-frame#update">
//
// Also accepts tom-select:change, which carries its value in event.detail
// because tom-select owns the data-controller attribute on the select itself:
// <div data-controller="dependent-frame"
//      data-action="tom-select:change->dependent-frame#update">
export default class extends Controller {
  static values = { urlTemplate: String, frame: String }

  declare readonly urlTemplateValue: string
  declare readonly frameValue: string

  update(event: Event): void {
    const detail = (event as CustomEvent).detail
    const value = detail?.value ?? (event.target as HTMLSelectElement).value
    const frame = document.getElementById(this.frameValue) as HTMLElement & { src?: string }
    if (frame && value) {
      frame.src = this.urlTemplateValue.replace('__ID__', value)
    } else if (frame) {
      frame.innerHTML = ''
    }
  }
}
